import * as yup from "yup";

import * as RHFGeneralRules from "@/utils/validation/schemas/general.RHF";
import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const ResetPasswordFormValidationSchema = yup.object({
    newPassword: RHFUserValidationRules.password,
    newPasswordRepeat: RHFUserValidationRules.passwordRepeat,
    email: RHFGeneralRules.hiddenValue,
    token: RHFGeneralRules.hiddenValue
});

export type ResetPasswordFormValues = yup.InferType<
    typeof ResetPasswordFormValidationSchema
>;
